export const QA_NAME_APPLICANT_PROFILE_COMPLIANCE = 'applicantProfileCompliance'

export const QA_NAME_APPLICANT_PROFILE_COMPLIANCE_HANDOFF =
  'applicantProfileComplianceHandoff'

export const QA_NAME_APPLICANT_PROFILE_COMPLIANCE_HANDOFF_DETAILS =
  'applicantProfileComplianceHandoffDetails'

export const QA_NAME_APPLICANT_PROFILE_COMPLIANCE_RELOAD =
  'applicantProfileComplianceReload'

export const QA_NAME_APPLICANT_PROFILE_COMPLIANCE_RETRY =
  'applicantProfileComplianceRetry'

export const QA_NAME_APPLICANT_PROFILE_COMPLIANCE_SCREENING =
  'applicantProfileComplianceScreening'

export const QA_NAME_APPLICANT_PROFILE_COMPLIANCE_SCREENING_DETAILS =
  'applicantProfileComplianceScreeningDetails'

export const QA_NAME_APPLICANT_PROFILE_COMPLIANCE_STATUS =
  'applicantProfileComplianceStatus'

export const APPLICANT_COMPLIANCE_NOT_STARTED_STATUS = 'not_started'

export const APPLICANT_COMPLIANCE_MATCH_COUNT_FALLBACK = 0

export const APPLICANT_COMPLIANCE_NEUTRAL_TEXT_COLOR =
  'var(--secondary-text-color)'

export const APPLICANT_COMPLIANCE_SCREENING_STATUS = {
  clear: 'clear',
  clearedFalsePositive: 'cleared_false_positive',
  confirmedHit: 'confirmed_hit',
  error: 'error',
  notStarted: APPLICANT_COMPLIANCE_NOT_STARTED_STATUS,
  potentialHit: 'potential_hit',
}

export const APPLICANT_COMPLIANCE_SCREENING_STATUS_KEY = {
  [APPLICANT_COMPLIANCE_SCREENING_STATUS.clear]:
    'RentalPortal.ApplicantComplianceScreeningStatusClearKey',
  [APPLICANT_COMPLIANCE_SCREENING_STATUS.clearedFalsePositive]:
    'RentalPortal.ApplicantComplianceScreeningStatusFalsePositiveKey',
  [APPLICANT_COMPLIANCE_SCREENING_STATUS.confirmedHit]:
    'RentalPortal.ApplicantComplianceScreeningStatusConfirmedHitKey',
  [APPLICANT_COMPLIANCE_SCREENING_STATUS.error]:
    'RentalPortal.ApplicantComplianceScreeningStatusErrorKey',
  [APPLICANT_COMPLIANCE_SCREENING_STATUS.notStarted]:
    'RentalPortal.ApplicantProfileComplianceNotStartedKey',
  [APPLICANT_COMPLIANCE_SCREENING_STATUS.potentialHit]:
    'RentalPortal.ApplicantComplianceScreeningStatusPotentialHitKey',
}

export const APPLICANT_COMPLIANCE_SCREENING_STATUS_TEXT_COLOR = {
  [APPLICANT_COMPLIANCE_SCREENING_STATUS.clear]: 'var(--color-success)',
  [APPLICANT_COMPLIANCE_SCREENING_STATUS.clearedFalsePositive]:
    'var(--color-success)',
  [APPLICANT_COMPLIANCE_SCREENING_STATUS.confirmedHit]: 'var(--color-error)',
  [APPLICANT_COMPLIANCE_SCREENING_STATUS.error]: 'var(--color-error)',
  [APPLICANT_COMPLIANCE_SCREENING_STATUS.notStarted]:
    APPLICANT_COMPLIANCE_NEUTRAL_TEXT_COLOR,
  [APPLICANT_COMPLIANCE_SCREENING_STATUS.potentialHit]: 'var(--color-warning)',
}

export const APPLICANT_COMPLIANCE_SCREENING_LINE_KEY = {
  [APPLICANT_COMPLIANCE_SCREENING_STATUS.clearedFalsePositive]:
    'RentalPortal.ApplicantComplianceScreeningFalsePositiveKey',
  [APPLICANT_COMPLIANCE_SCREENING_STATUS.confirmedHit]:
    'RentalPortal.ApplicantComplianceScreeningConfirmedKey',
  [APPLICANT_COMPLIANCE_SCREENING_STATUS.error]:
    'RentalPortal.ApplicantComplianceScreeningErrorKey',
  [APPLICANT_COMPLIANCE_SCREENING_STATUS.potentialHit]:
    'RentalPortal.ApplicantComplianceScreeningMatchOpenKey',
}

export const APPLICANT_COMPLIANCE_LIST_KEY = {
  eu_consolidated: 'RentalPortal.ApplicantComplianceListEuConsolidatedKey',
  un: 'RentalPortal.ApplicantComplianceListUnKey',
}

export const APPLICANT_COMPLIANCE_LEGAL_BASIS_KEY = {
  legal_obligation:
    'RentalPortal.ApplicantComplianceLegalBasisLegalObligationKey',
}

export const APPLICANT_COMPLIANCE_HANDOFF_STATUS = {
  blocked: 'blocked',
  delivered: 'delivered',
  failed: 'failed',
  notStarted: APPLICANT_COMPLIANCE_NOT_STARTED_STATUS,
  queued: 'queued',
  sent: 'sent',
}

export const APPLICANT_COMPLIANCE_HANDOFF_STATUS_KEY = {
  [APPLICANT_COMPLIANCE_HANDOFF_STATUS.blocked]:
    'RentalPortal.ApplicantComplianceHandoffStatusBlockedKey',
  [APPLICANT_COMPLIANCE_HANDOFF_STATUS.delivered]:
    'RentalPortal.ApplicantComplianceHandoffStatusDeliveredKey',
  [APPLICANT_COMPLIANCE_HANDOFF_STATUS.failed]:
    'RentalPortal.ApplicantComplianceHandoffStatusFailedKey',
  [APPLICANT_COMPLIANCE_HANDOFF_STATUS.notStarted]:
    'RentalPortal.ApplicantProfileComplianceNotStartedKey',
  [APPLICANT_COMPLIANCE_HANDOFF_STATUS.queued]:
    'RentalPortal.ApplicantComplianceHandoffStatusQueuedKey',
  [APPLICANT_COMPLIANCE_HANDOFF_STATUS.sent]:
    'RentalPortal.ApplicantComplianceHandoffStatusSentKey',
}

export const APPLICANT_COMPLIANCE_HANDOFF_STATUS_TEXT_COLOR = {
  [APPLICANT_COMPLIANCE_HANDOFF_STATUS.blocked]: 'var(--color-error)',
  [APPLICANT_COMPLIANCE_HANDOFF_STATUS.delivered]: 'var(--color-success)',
  [APPLICANT_COMPLIANCE_HANDOFF_STATUS.failed]: 'var(--color-error)',
  [APPLICANT_COMPLIANCE_HANDOFF_STATUS.notStarted]:
    APPLICANT_COMPLIANCE_NEUTRAL_TEXT_COLOR,
  [APPLICANT_COMPLIANCE_HANDOFF_STATUS.queued]: 'var(--color-warning)',
  [APPLICANT_COMPLIANCE_HANDOFF_STATUS.sent]: 'var(--color-warning)',
}

export const APPLICANT_COMPLIANCE_HANDOFF_LINE_KEY = {
  [APPLICANT_COMPLIANCE_HANDOFF_STATUS.delivered]:
    'RentalPortal.ApplicantComplianceHandoffDispatchedAtKey',
  [APPLICANT_COMPLIANCE_HANDOFF_STATUS.failed]:
    'RentalPortal.ApplicantComplianceHandoffFailedAtKey',
  [APPLICANT_COMPLIANCE_HANDOFF_STATUS.queued]:
    'RentalPortal.ApplicantComplianceHandoffQueuedAtKey',
  [APPLICANT_COMPLIANCE_HANDOFF_STATUS.sent]:
    'RentalPortal.ApplicantComplianceHandoffDispatchedAtKey',
}

export const APPLICANT_COMPLIANCE_HANDOFF_BLOCKED_REASON = {
  erpConnection: 'erp_connection',
  sanctionsHit: 'sanctions_hit',
}

export const APPLICANT_COMPLIANCE_HANDOFF_BLOCKED_REASON_KEY = {
  [APPLICANT_COMPLIANCE_HANDOFF_BLOCKED_REASON.erpConnection]:
    'RentalPortal.ApplicantComplianceHandoffBlockedConnectionKey',
  [APPLICANT_COMPLIANCE_HANDOFF_BLOCKED_REASON.sanctionsHit]:
    'RentalPortal.ApplicantComplianceHandoffBlockedSanctionsKey',
}

export const APPLICANT_COMPLIANCE_CONNECTION_STATUS_CONNECTED = 'connected'
